import AWS from 'aws-sdk'; // Import the entire SDK
import S3 from 'aws-sdk/clients/s3'; // Import only the S3 client
import toast from 'react-hot-toast';
import axios from 'axios';
const baseURL = process.env.REACT_APP_BASE_URL




// export const uploadFileToS3 = async (file) => {
//   const S3_BUCKET = "peerscroller"; // Replace with your bucket name
//   const REGION = "eu-west-2"; // Replace with your region

//   AWS.config.update({
//     accessKeyId: "AKIAQ3EGWBDCAQYL4TRU",
//     secretAccessKey: 'RM/F8Qp/RGhsUmwkEtgUxBMgaqoLFBYOhxJXM9GH'
//   });

//   const s3 = new S3({
//     params: { Bucket: S3_BUCKET },
//     region: REGION,
//   });

//   const timestamp = Date.now();
//   const folderName = "uploads/teacher"; // Specify your folder name here
//   const uniqueFileName = `${folderName}/${timestamp}_${file.name}`; 
//   const params = {
//     Bucket: S3_BUCKET,
//     Key: uniqueFileName,
//     Body: file,
//   };

//   try {
//     const upload = await s3.upload(params).promise();
//     return upload.Location; // Return the file URL
//   } catch (error) {
//     throw new Error("Error uploading file: " + error.message);
//   }
// };










export const uploadFileToS3 = async (file) => {
  const API_URL = '/school/content/file';
  const formData = new FormData();
  formData.append('image', file); // Changed the key to 'video'

  try {
    const response = await axios.post(`${baseURL}${API_URL}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (response.data.statusCode === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error uploading content:', error.response?.data || error.message);
    throw error; // Re-throw the error to handle it in the calling function
  }
};



export const truncateText = (text, wordLimit) => {
  if (!text) return 'N/A';
  const words = text.split(' ');
  if (words.length > wordLimit) {
    return words.slice(0, wordLimit).join(' ') + '...';
  }
  return text;
};

export const truncateTextbrowse = (text, wordLimit, charLimit = 30) => {
  if (!text) return 'N/A';

  // If the text is already within the character limit, return it as is
  if (text.length <= charLimit) return text;

  // Limit by word count first
  const words = text.split(' ');
  let truncated = words.slice(0, wordLimit).join(' ');

  // Then limit by character count if needed
  if (truncated.length > charLimit) {
    truncated = truncated.substring(0, charLimit).trim() + '...';
  } else {
    truncated += '...'; // Add ellipsis if original was longer
  }

  return truncated;
};


export const truncateTextNames = (text, wordLimit, charLimit = 10) => {
  if (!text) return 'N/A';

  // If the text is already within the character limit, return it as is
  if (text.length <= charLimit) return text;

  // Limit by word count first
  const words = text.split(' ');
  let truncated = words.slice(0, wordLimit).join(' ');

  // Then limit by character count if needed
  if (truncated.length > charLimit) {
    truncated = truncated.substring(0, charLimit).trim() + '...';
  } else {
    truncated += '...'; // Add ellipsis if original was longer
  }

  return truncated;
};


// export const deleteFileFromS3 = async (fileKey) => {
//   const S3_BUCKET = "peerscroller"; // Replace with your bucket name
//   const REGION = "eu-west-2"; // Replace with your region

//   AWS.config.update({
//     accessKeyId: "AKIAQ3EGWBDCLSYPDC74",
//     secretAccessKey: 'L+d1gdtzAn3YxPLnbPsHGCWuKkzkiAKyw9zIE6zq'
//   });

//   const s3 = new S3({
//     params: { Bucket: S3_BUCKET },
//     region: REGION,
//   });

//   const params = {
//     Bucket: S3_BUCKET,
//     Key: fileKey,
//   };

//   try {
//     await s3.deleteObject(params).promise();
//     return `File ${fileKey} deleted successfully.`;
//   } catch (error) {
//     throw new Error("Error deleting file: " + error.message);
//   }
// };


export function convertTime(minutes) {
  const hours = Math.floor(minutes / 60);  // Get the hours
  const remainingMinutes = minutes % 60;   // Get the remaining minutes

  if (hours > 0 && remainingMinutes > 0) {
    return `${hours}h ${remainingMinutes}m`;  // "Xh Ym"
  } else if (hours > 0) {
    return `${hours}h`;  // Only hours
  } else {
    return `${remainingMinutes}m`;  // Only minutes
  }
}


export function truncateEmail(email, maxLength) {
  if (email.length <= maxLength) {
    return email; // No truncation needed
  }

  const [username, domain] = email.split('@');

  // Calculate the remaining length for the username part
  const allowedUsernameLength = maxLength - domain?.length - 3; // 3 for "..."

  // Truncate the username and append "..."
  const truncatedUsername = username.slice(0, allowedUsernameLength) + '...';

  return `${truncatedUsername}@${domain}`;
}


export const uploadStudentCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ['firstname', 'surname', 'username', 'email', 'year',"group"];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      const text = e.target.result;

      const delimiters = [',', ';', '\t'];
      let delimiter = ',';
      let maxCount = 0;

      // Detect the correct delimiter
      delimiters.forEach((d) => {
        const count = (text.split('\n')[0].match(new RegExp(d, 'g')) || []).length;
        if (count > maxCount) {
          maxCount = count;
          delimiter = d;
        }
      });

      const lines = text.split('\n').filter(Boolean);

      if (lines.length > 1) {
        const headers = lines[0]
          .split(delimiter)
          .map((header) => header.trim().toLowerCase().replace(/^"|"$/g, '')); // Remove surrounding quotes
        // Debugging outputs
        const hasRequiredHeaders = requiredKeys.every((key) => headers.includes(key));

        if (hasRequiredHeaders) {
          const data = [];
          const usernameCount = {}; // Object to track how many times a username has been used

          for (let i = 1; i < lines.length; i++) {
            const values = lines[i].split(delimiter).map((value) => value.trim().replace(/^"|"$/g, '')); // Remove quotes from values
            const record = {};

            headers.forEach((header, index) => {
              if (requiredKeys.includes(header)) {
                record[header] = values[index];
              }
            });

            if (record.year) {
              const year = parseInt(record.year, 10);
              if ([7, 8, 9].includes(year)) {
                record.group = 3;
              } else if ([10, 11, 12].includes(year)) {
                record.group = 4;
              }
            }

            // Handle both user-provided and auto-generated usernames
            let baseUsername;
            if (record.username) {
              baseUsername = record.username.toLowerCase().replace(/[^a-z0-9]/gi, '');
            } else if (record.firstname && record.surname) {
              baseUsername = `${record.firstname}${record.surname}`.toLowerCase().replace(/[^a-z0-9]/gi, '');
            }

            if (baseUsername && baseUsername.length > 15) {
              baseUsername = baseUsername.substring(0, 15); // Maximum username length
            }

            if (baseUsername) {
              let newUsername = baseUsername;

              if (usernameCount[baseUsername]) {
                usernameCount[baseUsername]++;
                newUsername = `${baseUsername}${usernameCount[baseUsername]}`;
              } else {
                usernameCount[baseUsername] = 1;
              }

              record.username = newUsername;
            }

            if (!record.email) {
              toast.error(`One of the records is missing an email.`);
              resolve([]);
              return;
            }

            data.push(record);
          }

          resolve(data);
        } else {
          const missingHeaders = requiredKeys.filter((key) => !headers.includes(key));
          reject(new Error(`Missing required headers: ${missingHeaders.join(', ')}`));
        }
      } else {
        reject(new Error('No data found in the CSV'));
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
};



export const uploadTeacherCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ['firstname', 'surname', 'email', 'department'];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      const text = e.target.result;

      // Detect the delimiter
      const delimiters = [',', ';', '\t'];
      const delimiter = delimiters.find((d) => text.includes(d)) || ',';

      // Split the CSV into lines
      const lines = text.split('\n').filter(Boolean);

      if (lines.length > 1) {
        // Extract headers and normalize them
        const originalHeaders = lines[0].split(delimiter).map((header) => header.trim());
        const normalizedHeaders = originalHeaders.map((header) => {
          const cleaned = header.toLowerCase().replace(/^"|"$/g, '');
          // Handle camelCase to lowercase conversion
          if (cleaned === 'firstname' || cleaned === 'firstname') return 'firstname';
          if (cleaned === 'surname' || cleaned === 'surname') return 'surname';
          return cleaned;
        });

        // Check if the required headers are present
        const hasRequiredHeaders = requiredKeys.every((key) => normalizedHeaders.includes(key));

        if (hasRequiredHeaders) {
          const data = [];

          for (let i = 1; i < lines.length; i++) {
            const values = lines[i].split(delimiter).map((value) => value.trim().replace(/^"|"$/g, ''));
            const record = {};

            normalizedHeaders.forEach((header, index) => {
              if (requiredKeys.includes(header)) {
                record[header] = values[index];
              }
            });

            // Check if the email is missing
            if (!record.email) {
              toast.error(`One of the records is missing an email.`);
              resolve([]); // Return empty data
              return;
            }

            data.push(record);
          }

          resolve(data);
        } else {
          toast.error(`Missing required headers: ${requiredKeys.join(', ')}`);
          resolve([]); // Return empty data if required headers are missing
        }
      } else {
        toast.error('No data found in the CSV');
        resolve([]); // Return an empty array if there's no data
      }
    };

    reader.onerror = () => {
      toast.error('Failed to read file');
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
};



export const uploadSchoolAdminCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ['firstname', 'surname', 'email', 'department'];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      const text = e.target.result;

      const delimiters = [',', ';', '\t'];
      const delimiter = delimiters.find((d) => text.includes(d)) || ',';

      const lines = text.split(/\r?\n/).filter(Boolean);

      if (lines.length > 1) {
        const headers = lines[0]
          .split(delimiter)
          .map((h) =>
            h.replace(/^\ufeff/, '')   // remove BOM
             .replace(/^"|"$/g, '')    // remove surrounding quotes
             .trim()
             .toLowerCase()
          );

        const hasRequiredHeaders = requiredKeys.every((key) =>
          headers.includes(key)
        );

        if (!hasRequiredHeaders) {
          toast.error(`Missing required headers: ${requiredKeys.join(', ')}`);
          resolve([]);
          return;
        }

        const data = [];

        for (let i = 1; i < lines.length; i++) {
          const values = lines[i]
            .split(delimiter)
            .map((v) => v.replace(/^"|"$/g, '').trim()); // strip quotes

          const record = {};

          headers.forEach((header, idx) => {
            if (requiredKeys.includes(header)) {
              record[header] = values[idx] || '';
            }
          });

          if (!record.email) {
            toast.error(`Row ${i} is missing an email.`);
            resolve([]);
            return;
          }

          data.push(record);
        }

        resolve(data);
      } else {
        toast.error('No data found in the CSV');
        resolve([]);
      }
    };

    reader.onerror = () => {
      toast.error('Failed to read file');
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
};





export const uploadParentCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ['firstname', 'surname', 'username', 'email', 'year','group'];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      const text = e.target.result;

      const delimiters = [',', ';', '\t'];
      const delimiter = delimiters.find((d) => text.includes(d)) || ',';

      const lines = text.split(/\r?\n/).filter(Boolean);

      if (lines.length > 1) {
        const headers = lines[0]
          .split(delimiter)
          .map((h) =>
            h.replace(/^\ufeff/, '')   // remove BOM
             .replace(/^"|"$/g, '')    // remove surrounding quotes
             .trim()
             .toLowerCase()
          );

        const hasRequiredHeaders = requiredKeys.every((key) =>
          headers.includes(key)
        );

        if (!hasRequiredHeaders) {
          toast.error(`Missing required headers: ${requiredKeys.join(', ')}`);
          resolve([]);
          return;
        }

        const data = [];

        for (let i = 1; i < lines.length; i++) {
          const values = lines[i]
            .split(delimiter)
            .map((v) => v.replace(/^"|"$/g, '').trim()); // strip quotes

          const record = {};

          headers.forEach((header, idx) => {
            if (requiredKeys.includes(header)) {
              record[header] = values[idx] || '';
            }
          });

          if (!record.email) {
            toast.error(`Row ${i} is missing an email.`);
            resolve([]);
            return;
          }

          data.push(record);
        }

        resolve(data);
      } else {
        toast.error('No data found in the CSV');
        resolve([]);
      }
    };

    reader.onerror = () => {
      toast.error('Failed to read file');
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
};




export const constructQueryString = (obj) => {
  if (obj) {
    const queryString = Object.keys(obj)
      .filter(key => obj[key] !== "" && obj[key] !== null && obj[key] !== undefined)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      .join('&');
    return queryString;
  } else {
    return ""
  }
}



export const getQueryParams = (search) => {
  const params = new URLSearchParams(search);
  const queryObject = { categories: "", selectedGroup: "", searchkey: "" }; // Default keys with empty strings

  for (const [key, value] of params.entries()) {
    queryObject[key] = value ?? ""; // Ensures empty string for missing values
  }

  return queryObject;
};


export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};